// Constants for different requests for current reducer
export default {
  SITE_EMAIL_SETTINGS: 'SITE_EMAIL_SETTINGS',
  UPDATE_SITE_EMAIL_SETTING: 'UPDATE_SITE_EMAIL_SETTING',
  SITE_EMAIL_RECIPIENTS: 'SITE_EMAIL_RECIPIENTS',
  UPDATE_SITE_EMAIL_RECIPIENTS: 'UPDATE_SITE_EMAIL_RECIPIENTS',
};
